import React, { useState, useEffect, useRef } from 'react';
import PropTypes from 'prop-types';
import { find, isEmpty } from 'lodash';
import DynamicDataGrid from '../common/DynamicDataGrid/DynamicDataGrid';
import { numberWithCommas } from '../../util/CommonUtils';
import { PROBABILTIES_FUNCTIONS } from '../../constants';
import CommonSelect from '../common/CommonSelect';
import FunctionBoxButtonGroupV2 from './FunctionBoxButtonGroupV2';


const commaFormatter = ({ value }) => <div>{numberWithCommas(value)}</div>;
commaFormatter.propTypes = {
  value: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
};

const FunctionBoxPublicationsV2 = props => {
  const getRowsData = sampleWeightedValues => {
    if (sampleWeightedValues.length > 0) {
      return props.selectedTargets.map((item, index) => ({
        description: item.shortText,
        keyword: item.keyword,
        midpoint: item.midpoint ? item.midpoint : 0,
        weight: sampleWeightedValues[index].weighted,
        total: item.midpoint
          ? item.midpoint * sampleWeightedValues[index].weighted
          : 0,
      }));
    }

    return [];
  };

  const getColumns = () => {
    return [
      { key: 'description', name: 'Description', sortable: true, width: 200 },
      { key: 'keyword', name: 'Keyword', sortable: true, width: 200 },
      {
        key: 'weight',
        name: 'Weight',
        sortable: true,
        width: 150,
        formatter: commaFormatter,
      },
      {
        key: 'total',
        name: 'Total',
        sortable: true,
        width: 150,
        formatter: commaFormatter,
      },
    ];
  };

  const [rowsData, setRowsData] = useState(props.sampleWeightedValues
    ? getRowsData(props.sampleWeightedValues)
    : []);
  const [selectedFunc, setSelectedFunc] = useState({ label: 'Average Issue', value: 'avg' });
  const [functionList, setFunctionList] = useState([isEmpty(props.probabilityFunctionList) ? [] :
    props.probabilityFunctionList]);

  // on load getting the function list
  useEffect(() => {
    if (isEmpty(props.probabilityFunctionList)) {
      props.moduleAction.getFunctionsForProbabilities();
    }
  }, []);

  // on change of sample weighted update the grid
  useEffect(() => {
    setRowsData(props.sampleWeightedValues
      ? getRowsData(props.sampleWeightedValues)
      : []);
  }, [props.sampleWeightedValues]);

  // After getting new set of function list
  useEffect(() => {
    setFunctionList(props.probabilityFunctionList
      ? setFunctionList(props.probabilityFunctionList)
      : []);
  }, [props.probabilityFunctionList]);

  const createSmartSearchArray = () => {
    const selectedTargets = _.cloneDeep(props.selectedTargets);
    const objSmartSearchArray = {};
    const objectsAdded = [];
    const expressionFormed = [];
    const tags = [];

    selectedTargets.forEach(target => {
      const breadcrumbList = JSON.parse(window.localStorage.getItem('breadCrumb'));
      const breadCrumbValue = breadcrumbList ? breadcrumbList.reverse().join(' > ') : undefined;

      target.breadcrumbs = breadCrumbValue;
      objectsAdded.push(target);
      expressionFormed.push(target.keyword);
      tags.push(target.shortText);
    });
    objSmartSearchArray.objectsAdded = objectsAdded;
    objSmartSearchArray.expressionFormed = expressionFormed;
    objSmartSearchArray.tags = tags;

    return objSmartSearchArray;
  };

  const createExpression = () => {
    let expressionKeyword = `${selectedFunc.value} (`;
    expressionKeyword = rowsData.reduce(
      (acc, item) => `${acc} ${item.keyword} , `,
      expressionKeyword,
    );
    expressionKeyword = expressionKeyword.slice(0, -2);
    expressionKeyword = `${expressionKeyword} )`;

    return expressionKeyword;
  };

  const moveAppendToCodingBox = isMove =>
    props.moveAppendToCodingBox(isMove, createExpression(), createSmartSearchArray());

  const moveToColumns = () => {
    if (props.functionTitle) {
      props.moveToColumns(createExpression(), createSmartSearchArray());
    } else {
      props.moveToColumns();
    }
  };

  const moveToRows = () => {
    if (props.functionTitle) {
      props.moveToRows(createExpression(), createSmartSearchArray());
    } else {
      props.moveToRows();
    }
  };

  const addToDefinitionModal = () => {
    if (props.functionTitle) {
      props.addToDefinition(createExpression());
    } else {
      props.addToDefinition();
    }
  };

  const onCategoryChange = node => {
    const obj = find(props.probabilityFunctionList, e => e.value === node);
    setSelectedFunc(obj);
  };

  return (
    <div className="function-box-average">
      <div className="row expanded">
        <div className="small-12 medium-8 large-9 columns padding-left-0">
          <DynamicDataGrid
            gridCategory="FunctionBoxGrid"
            className="saved-crosstab-grid"
            gridHeight={315}
            gridWidth={700}
            rows={rowsData}
            columns={getColumns()}
            rowSelectionType="Single"
            isCellSelectable
            minimunRows={8}
          />
        </div>
        <div className="small-12 medium-3 large-3 columns function-position">
          <div
            className="row function-box-probabilities"
            data-test="countyAndZipcodeComp"
          >
            <CommonSelect
              data-test="CustomSelectComp"
              cClass="mme-rpt-second-select"
              field={props.probabilityFunctionList}
              onSelection={onCategoryChange}
              defaultValue={selectedFunc.value}
              defaultLabel={selectedFunc.label}
              downArrow
              width="200px"
              buttonStyle={{
                border: '1px solid #91a2b9',
                fontWeight: '400',
                color: '#30435d',
                height: '30px',
                marginBottom: '15px',
              }}
              appendValue={true}
            />
          </div>
          <div className="clearfix margin-top-10">
            <FunctionBoxButtonGroupV2
              moveAppendToCodingBox={moveAppendToCodingBox}
              moveToColumns={moveToColumns}
              moveToRows={moveToRows}
              addToDefinitionModal={addToDefinitionModal}
              noExpressionBox={props.noExpressionBox}
              noCRB={props.noCRB}
            />
          </div>
        </div>
      </div>
    </div>
  );
};

FunctionBoxPublicationsV2.propTypes = {
  noCRB: PropTypes.bool,
  noExpressionBox: PropTypes.bool,
  sampleWeightedValues: PropTypes.arrayOf(PropTypes.object),
  probabilityFunctionList: PropTypes.arrayOf(PropTypes.object),
};

export default FunctionBoxPublicationsV2;
